import { useState } from 'react';

// r130: shared drag-and-drop + clipboard-paste plumbing for upload surfaces.
// Spread `dropProps` on the drop target and `pasteProps` on the focusable
// element (textarea/input). Text pastes are untouched — the paste handler
// only claims the event when the clipboard actually carries files.
export function useFileDrop(onFiles) {
  const [dragOver, setDragOver] = useState(false);
  return {
    dragOver,
    dropProps: {
      // File drags only — a text drag (e.g. selected text dropped into a
      // textarea inside the target) keeps its native behavior untouched.
      onDragOver: (e) => {
        if (!e.dataTransfer?.types?.includes('Files')) return;
        e.preventDefault(); e.stopPropagation(); setDragOver(true);
      },
      onDragLeave: (e) => { e.preventDefault(); e.stopPropagation(); setDragOver(false); },
      onDrop: (e) => {
        setDragOver(false);
        if (!e.dataTransfer?.types?.includes('Files')) return;
        e.preventDefault(); e.stopPropagation();
        const files = Array.from(e.dataTransfer?.files || []);
        if (files.length) onFiles(files);
      },
    },
    pasteProps: {
      onPaste: (e) => {
        const files = Array.from(e.clipboardData?.items || [])
          .filter((i) => i.kind === 'file')
          .map((i) => i.getAsFile())
          .filter(Boolean);
        if (files.length) { e.preventDefault(); onFiles(files); }
      },
    },
  };
}
